<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list
          @form="dialog = true"
          @view="view = true"
          @clear="$refs.form && $refs.form.clear()"
        />
        <form-manager
          v-if="dialog"
          ref="form"
          :dialog="dialog"
          @close="dialog = false"
        />
        <entity-view v-if="view" :dialog="view" @close="view = false" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import EntityView from './EntityView'
import FormManager from './FormManager'
import List from './List'

export default {
  name: 'Entities',
  components: {
    List,
    FormManager,
    EntityView,
  },
  data() {
    return {
      dialog: false,
      view: false,
    }
  },
  mounted() {
    // this.resetState()
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      fetchEntities: 'entities/fetchList',
      resetState: 'entities/resetState',
      setStatus: 'events/setStatus',
    }),
    async initData() {
      // this.resetPagitations()
      await Promise.all([this.fetchEntities()])
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
  },
}
</script>
